// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import measurementsConnect from '../../measurementsStore/measurementsConnect';
import { hasChanged } from '../../../utils/react/propsComparisons';

// Selector
import { createShallowSelector } from '../../../utils/milanoteReselect/milanoteReselect';
import {
    getPoiCommentId,
    getPoiElementId,
    getPoiIsCommentActivity,
    getPoiIsElementChange,
    getPoiMap,
    getPoiNotificationId,
    getPoiSection,
    getPoiSeen,
} from '../poiSelector';

// Actions
import { markPoisAsSeen } from '../poiActions';
import { markNotificationElementsAsSeen } from '../../../notifications/notificationActions';

// Constants
import { BoardSections } from '../../../../common/boards/boardConstants';
import { isEmpty } from '../../../../common/utils/immutableHelper';

const unseenPoisHasChanged = hasChanged('unseenPois');

const mapDispatchToProps = (dispatch) => ({
    dispatchMarkNotificationElementsAsSeen: (elementViews, commentViews) =>
        dispatch(markNotificationElementsAsSeen({ views: elementViews, commentViews })),
});

const unseenInboxPoisSelector = createShallowSelector(getPoiMap, (pois) =>
    pois.filter((poi) => getPoiSection(poi) === BoardSections.INBOX && !getPoiSeen(poi)),
);

const mapMeasurementsStateToProps = createStructuredSelector({
    unseenPois: unseenInboxPoisSelector,
});

const mapMeasurementsDispatchToProps = (dispatch) => ({
    dispatchSeenPois: ({ ids }) => dispatch(markPoisAsSeen({ ids })),
});

/**
 * NOTE: Ensure this component is only mounted if the inbox is open.
 */
export default (DecoratedComponent) => {
    @connect(null, mapDispatchToProps)
    @measurementsConnect(mapMeasurementsStateToProps, mapMeasurementsDispatchToProps)
    class MarkSeenInboxPointersDecorator extends React.Component {
        componentWillMount() {
            this.markVisiblePointsOfInterestAsSeen(this.props);
        }

        componentWillReceiveProps(nextProps) {
            if (unseenPoisHasChanged(this.props, nextProps)) {
                this.markVisiblePointsOfInterestAsSeen(nextProps);
            }
        }

        markVisiblePointsOfInterestAsSeen = (props) => {
            const { unseenPois, dispatchSeenPois, dispatchMarkNotificationElementsAsSeen } = props;

            if (isEmpty(unseenPois)) return;

            const unseenPoiIds = unseenPois.keySeq().toArray();

            dispatchSeenPois({ ids: unseenPoiIds });

            const unseenElementViews = [];
            const unseenCommentViews = [];

            unseenPois.forEach((poi) => {
                if (getPoiIsElementChange(poi)) {
                    unseenElementViews.push({
                        elementId: getPoiElementId(poi),
                        notificationId: getPoiNotificationId(poi),
                    });
                } else if (getPoiIsCommentActivity(poi)) {
                    unseenCommentViews.push({
                        commentId: getPoiCommentId(poi),
                        notificationId: getPoiNotificationId(poi),
                    });
                }
            });

            if (!isEmpty(unseenElementViews) || !isEmpty(unseenCommentViews)) {
                dispatchMarkNotificationElementsAsSeen(unseenElementViews, unseenCommentViews);
            }
        };

        render() {
            return <DecoratedComponent {...this.props} />;
        }
    }

    MarkSeenInboxPointersDecorator.propTypes = {
        unseenPois: PropTypes.array,
        dispatchSeenPois: PropTypes.func,
        dispatchMarkNotificationElementsAsSeen: PropTypes.func,
    };

    return MarkSeenInboxPointersDecorator;
};
